export default "__VITE_ASSET__Dbu43hce__"